import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";
import Tooltip from "@components/tooltip";

import RefreshAnswer from "./RefreshAnswer";
import Refresh from "./Refresh";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const licenseOption = {
  FREE_ACCESS: 0,
  ADD: 1,
  EXTEND: 2,
};

const LicenseGroup = ({
  children,
  refreshAction,
  refreshError,
  after,
  href,
  onClick,
  hidePlusIcon,
  refreshDisabled,
  refreshLoading,
  option,
}) => {
  const [refreshHovered, setRefreshHovered] = useState(false);

  const onMouseEnterRefresh = () => {
    setRefreshHovered(true);
  };

  const onMouseLeaveRefresh = () => {
    setRefreshHovered(false);
  };

  let tooltipPlusText = strings.profile_add_new;

  if (option === licenseOption.ADD) {
    tooltipPlusText = strings.profile_add;
  } else if (option === licenseOption.EXTEND) {
    tooltipPlusText = strings.profile_extend;
  }

  return (
    <a className={cx("licenses-wrapper")} href={href} onClick={onClick}>
      <div className={cx("licenses")}>
        <span className={cx("licenses-label")}>{children}</span>
        <span className={cx("icons-block")}>
          <Refresh
            className={cx({ "plus-button-hidden": hidePlusIcon })}
            onMouseEnter={onMouseEnterRefresh}
            onMouseLeave={onMouseLeaveRefresh}
            action={refreshAction}
            loading={refreshLoading}
            disabled={refreshDisabled}
          />
          {!hidePlusIcon && (
            <Tooltip content={tooltipPlusText} duration={[null, null]}>
              <Icon
                className={cx("plus-icon", { hovered: refreshHovered })}
                name="ic_add-out"
                size="s"
                color="var(--glz-color-neutral-tone-5)"
              />
            </Tooltip>
          )}
        </span>
      </div>
      {!!refreshError && <RefreshAnswer text={refreshError} />}
      <object className={cx("object-wrapper")}>{after}</object>
    </a>
  );
};

LicenseGroup.propTypes = {
  children: PropTypes.node,
  refreshAction: PropTypes.func,
  refreshError: PropTypes.string,
  after: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func,
  hidePlusIcon: PropTypes.bool,
  refreshLoading: PropTypes.bool,
  refreshDisabled: PropTypes.bool,
  option: PropTypes.number,
};

export default LicenseGroup;

export { licenseOption };
